import React, { useContext } from 'react';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';
import useNavigation from '@hooks/useNavigation.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import { Link } from 'react-router-dom';

interface ConditionalLinkedResBadgeProps {
  route?: {
    linkedReservation?: {
      applicationId: string;
      id?: string;
    }
  };
}

const ConditionalLinkedResBadge: React.FC<ConditionalLinkedResBadgeProps> = ({ route }) => {
  const { hasPermission } = useContext(AuthenticatedUserContext);
  const navigation = useNavigation();
  const { tr } = useTranslationLgs();

  if (!route?.linkedReservation?.applicationId) {
    return null;
  }

  const { linkedReservation } = route;

  if (hasPermission([PermissionTypesEnum.PERMISSION_TIMESLOT_DETAIL_READ, PermissionTypesEnum.PERMISSION_TIMESLOT_DETAIL_RW])) {
    return linkedReservation.id
      ? (
        <div className="px-2 py-1 bg-[#ffeee5] rounded text-sm inline-flex flex-wrap w-fit mt-2">
        <span className="text-gray-600">
          {tr(`LinkedResBadge.reservation`, `Reservation`)}
        </span>
          <Link to={navigation.createNavigationLink(navigation.urlFunctions.createReservationDetail(linkedReservation.id),)}>
          <span className="font-medium hover:text-orange-800 ml-1">
            {linkedReservation.applicationId}
          </span>
          </Link>
        </div>
      )
      : <span className="font-medium hover:text-orange-800 ml-1">
          {linkedReservation.applicationId}
        </span>;
  } else {
    return <span className="font-medium hover:text-orange-800 ml-1">
      {linkedReservation.applicationId}
    </span>;
  }
};

export default ConditionalLinkedResBadge;
